import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { Toaster } from "react-hot-toast";
import MainPage from "./page/Main/MainTest.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";
import PassengerPage from "./page/Passenger/Passenger.tsx";
import DriverPage from "./page/Driver/Driver.tsx";
import CrossBorderPage from "./page/Cross-Border/Cross_Border_Travel.tsx";
import SharedRidePage from "./page/Shared_Ride/Shared_Ride.tsx";
import BookingPage from "./page/Booking/BookingPage.tsx";
import LoginPage from "./page/Auth/Login.tsx";
import Toast from "./components/Toast";
import RegisterPage from "./page/Auth/Register";
import OrderDetailPage from "./page/OrderDetail/OrderDetail";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" reverseOrder={false} toastOptions={{ duration: 2000 }} />
      <Toast />
      <div>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainPage />}></Route>
            <Route path='/passenger' element={<PassengerPage />}></Route>
            <Route path='/driver' element={<DriverPage />}></Route>
            <Route path='/cross-border' element={<CrossBorderPage />}></Route>
            <Route path='/shared-ride' element={<SharedRidePage />}></Route>
            <Route path="/book" element={<BookingPage />}></Route>
            <Route path="/login" element={<LoginPage />}></Route>
            <Route path="/register" element={<RegisterPage />}></Route>
            <Route path="/order/detail" element={<OrderDetailPage />}></Route>
            <Route path="/zh-hans/*" element={<MainPage />}></Route>
            <Route path="/zh-hant/*" element={<MainPage />}></Route>
            <Route path="/en/*" element={<MainPage />}></Route>
          </Routes>
          <ScrollToTop />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
